import {Alert, DatePicker, Flex} from 'antd'
import FormItem from 'antd/es/form/FormItem'
import {FormInstance} from 'antd/lib/form'
import dayjs from 'dayjs'

const FORMAT_DAY = 'YYYY-MM-DD'

interface Props<T> {
    entity: T
    setEntity: (entity: T) => void
    form: FormInstance
    lookupEntity?: any
    lookupMessage?: string
    tooltip?: string
}

const dateCheck = (entity: any, lookupEntity: any) => {
    if (entity.startDate
        && dayjs(entity.startDate)
        && lookupEntity.startDate
        && dayjs(lookupEntity.startDate)) {
        if (dayjs(entity.startDate).isBefore(dayjs(lookupEntity.startDate))) {
            return false;
        }
    }
    if (entity.endDate
        && dayjs(entity.endDate)
        && lookupEntity.endDate
        && dayjs(lookupEntity.endDate)) {
        if (dayjs(entity.endDate).isAfter(dayjs(lookupEntity.endDate))) {
            return false;
        }
    }
    return true;
}

export const StartEndDates = <T extends object>({entity, setEntity, form, lookupEntity, lookupMessage, tooltip}: Props<T>) =>
    <FormItem name="dates" label="Dates" tooltip={tooltip} required
              rules={[
                  () => ({
                      validator(_, _value) {
                          if (entity['startDate'] && entity['endDate']) {
                              return Promise.resolve()
                          }
                          return Promise.reject(new Error('Please select both Start Date & End Date'))
                      }
                  })
              ]}
    >
        <Flex>
            <DatePicker
                value={entity['startDate'] && dayjs(entity['startDate'])}
                style={{ width: 200 }}
                onChange={(value) => {
                    setEntity({ ...entity, startDate: value && value.format(FORMAT_DAY) })
                    form.resetFields(['dates'])
                }}
                disabledDate={(date) => !!entity['endDate'] && date.isAfter(entity['endDate'], 'day')}
                placeholder="Start Date"
                format="DD MMM YYYY"
                width={200}
            />
            <span style={{ marginLeft: 8, marginRight: 8, fontSize: 18 }}>-</span>
            <DatePicker
                value={entity['endDate'] && dayjs(entity['endDate'])}
                style={{ width: 200 }}
                onChange={(value) => {
                    setEntity({ ...entity, endDate: value && value.format(FORMAT_DAY) })
                    form.resetFields(['dates'])
                }}
                disabledDate={(date) => !!entity['startDate'] && date.isBefore(entity['startDate'], 'day')}
                placeholder="End Date"
                format="DD MMM YYYY"
                width={200}
            />
            <span style={{ marginLeft: 8, marginRight: 8, fontSize: 18 }}/>
        </Flex>
        {lookupEntity && lookupMessage && !dateCheck(entity, lookupEntity) && <Alert
          description={lookupMessage}
          type="warning"
          showIcon
          style={{marginTop: 10}}
          closable
        />}
    </FormItem>
